import { render } from "./AsNumbersTab.vue?vue&type=template&id=63cb4d45&scoped=true"
import script from "./AsNumbersTab.vue?vue&type=script&lang=js"
export * from "./AsNumbersTab.vue?vue&type=script&lang=js"

import "./AsNumbersTab.vue?vue&type=style&index=0&id=63cb4d45&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cb4d45"]])

export default __exports__